module.exports = __webpack_public_path__ + "media/assets/icons/calculator-08559ed181135b3e83e9edf4e1471df6.svg";